export default {
  search_placeholder: "搜索常见问题...",
  no_results_title: "未找到结果",
  no_results_subtitle: "尝试调整搜索关键词或浏览左侧分类。",
  search_cleared_message: "已清除搜索，显示完整内容",
  still_have_questions: {
    before_email: "还有疑问？请联系 ",
    after_email: " — 我们的团队将在24小时内回复。",
  },
};
